import store from "../../index"
export default function TOGGLE_ALL_USERS() {
    store.adminDashboard.state.toggleAllUsers = !store.adminDashboard.state.toggleAllUsers
}